import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import ProductForm from '~/components/productForm/productForm';
import { productValidationSchema } from '../../validation/product';

export const createProductsMutation = gql`
  mutation createProduct(
    $breweryId: Int!
    $beerStyleId: Int!
    $name: String!
    $customsName: String
    $description: String
    $lotPrefix: String!
    $abv: Float!
    $volume: Int!
    $hsCodeId: Int
    $costPerLitre: Float!
    $ingredients: [IngredientForProductCreate]!
    $variants: [ProductVariantForProductCreate]
  ) {
    createProduct(
      breweryId: $breweryId
      beerStyleId: $beerStyleId
      name: $name
      customsName: $customsName
      description: $description
      abv: $abv
      lotPrefix: $lotPrefix
      volume: $volume
      hsCodeId: $hsCodeId
      costPerLitre: $costPerLitre
      ingredients: $ingredients
      variants: $variants
    ) {
      id
      name
      customsName
      description
      abv
      volume
      ingredients {
        id
      }
    }
  }
`;

export const ProductCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createProductsMutation}>
      {(createProduct, { error }) => (
        <Formik
          initialValues={{
            ingredients: [
              {
                measurementType: 'KG'
              }
            ],
            variants: [{}]
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={productValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newProduct = await createProduct({
                variables: {
                  ...values,
                  breweryId: brewery.id
                },
                refetchQueries: ['products']
              });
              history.push(`/products?new=${newProduct.data.createProduct.name}`);
            } catch (err) {
              console.error('Error creating new product', err);
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={ProductForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(ProductCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/productCreate/productCreate.jsx